import type { AppConfig } from './index';

// Default configuration values
export const DEFAULT_CONFIG: AppConfig = {
  // Branding defaults - none, will show text fallback
  logo_light_url: undefined,
  logo_dark_url: undefined,
  logo_mark_light_url: undefined,
  logo_mark_dark_url: undefined,
  logo_width: 120,
  login_logo_width: 200,
  favicon_url: undefined,
  portal_name: 'Connor Music Audit Portal',
};

